import React from 'react';
import { Navigate } from 'react-router-dom';
import {GetUser} from "./helpers/User";
import Axios from "axios";
import {deleteCookie} from "./helpers/Cookie";

const ProtectedRoute = ({ component: Component, token, ...rest }) => {
    if (token) {
        GetUser().then(user => {
            if (!user) {
                delete Axios.defaults.headers.common['Authorization'];
                deleteCookie("telos_auth");
                return window.location.replace("/unauthorized");
            }
        });
        return <Component {...rest} />
    } else {
        return <Navigate to="/unauthorized" replace />
    }
}

export default ProtectedRoute;
